import React from 'react';
import Timestamp from '../../components/Timestamp';
import { gql } from '../../graphql/generated';
import type { DocumentType } from '../../graphql/generated/gql';
import VerifiedIcon from '../VerifiedIcon';
import getVerificationStatus, {
  VerificationStatus,
} from '../getVerificationStatus';
import * as styles from './ControlBarInsightsButtonContent.module.scss';

const BUTTON_CONTENT_POST_FRAGMENT = gql(`
  fragment ControlBarInsightsButtonContent_post on Post {
    id
    publishedAt
    archivedAt
    editedAt
    insertedAt
    verificationEntries {
      id
      verifiedAt
    }
    ...getVerificationStatus_post
  }
`);

interface ControlBarInsightsButtonContentProps {
  post: DocumentType<typeof BUTTON_CONTENT_POST_FRAGMENT>;
}

export const ControlBarInsightsButtonContent = ({
  post,
}: ControlBarInsightsButtonContentProps) => {
  const verificationStatus = getVerificationStatus(post);
  const verifiedAt = post.verificationEntries[0]?.verifiedAt as
    | string
    | undefined;

  return (
    <>
      {post.publishedAt &&
      !post.archivedAt &&
      verificationStatus === VerificationStatus.Verified &&
      verifiedAt ? (
        <div className={styles.verifiedContainer}>
          <div className={styles.verifiedIcon}>
            <VerifiedIcon />
          </div>
          <div>
            Verified <Timestamp date={verifiedAt} />
          </div>
        </div>
      ) : (
        <>
          Edited <Timestamp date={post.editedAt || post.insertedAt} />
        </>
      )}
    </>
  );
};
